import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/index'
import VueI18n from 'vue-i18n'
import '../static/css/common.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import 'video.js/dist/video-js.css'; //视频样式

import '../static/ppt/css/pptxjs.css'
import '../static/ppt/css/nv.d3.min.css'

import '../static/ppt/js/jszip.min.js'
import '../static/ppt/js/filereader.js'
import '../static/ppt/js/jquery-1.11.3.min.js'
import '../static/ppt/js/d3.min.js'
import '../static/ppt/js/nv.d3.min.js'
import '../static/ppt/js/pptxjs.js'
import '../static/ppt/js/divs2slides.js'


import AES from "./utils/AES.js";
Vue.prototype.$AES = AES;

import Viewer from 'v-viewer';  //图片预览
import 'viewerjs/dist/viewer.css';  //图片预览样式
import "quill/dist/quill.snow.css";    //富文本的样式
// import './components/wjlEditor/index.css';     //富文本的样式
import "./libs/drag/drag";
import "./components/paginator/paginator.scss"
import axios from 'axios'
// import qs from 'qs';
import VCharts from 'v-charts'
import replace from "./utils/replace"
import VueContextMenu from 'vue-contextmenu' // 右击菜单
// window.Quill = require('quill')
import JsonViewer from 'vue-json-viewer'

import NButton from "./views/szrt_revision/components/n_button.vue"
Vue.component('n-button', NButton);

import NTable from "./views/szrt_revision/components/n_table.vue"
Vue.component('n-table', NTable);

import NDialog from "./views/szrt_revision/components/n_dialog.vue"
Vue.component('n-dialog', NDialog);

import NSearchInput from "./views/szrt_revision/components/n_searchInput.vue"
Vue.component('n-search-input', NSearchInput);

import cryptoJS from 'crypto-js'
Vue.use(cryptoJS);

import './libs/FormValidate'
import '../static/icons/iconfont.js'
import './libs/drag/DialogDirectives'

Vue.use(JsonViewer)
Vue.use(VCharts)
Vue.use(VueContextMenu)
// 动产
import 'babel-polyfill' //兼容ie
import TipsDialog from '../src/components/dialog/tipsDialog/index'
import TipsNewDialog from '../src/components/dialog/tipsNewDialog/index'
import delHtmlTag from "./utils/delHtmlTag"
import './libs/AjaxPost.js'
import './libs/ObjectPrototypes'

//echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

import JSONBIG from 'json-bigint';

import {downloadFun, setJsonBig} from "./utils/utils"
Vue.prototype.$downloadFun = downloadFun;
Vue.prototype.$setJsonBig = setJsonBig; // 处理JSON中的超过12位数值 ，解决超过16位数字解析精度丢失问题

Vue.prototype.$bus = new Vue();

Vue.use(TipsDialog)
Vue.use(TipsNewDialog)
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(VueI18n)
Vue.use(VueAwesomeSwiper)
Vue.use(Viewer);
// Vue.prototype.$qs = qs;
Vue.prototype.$replace = replace;
Vue.prototype.$delHtmlTag = delHtmlTag;
Viewer.setDefaults({
  "inline": false,
  "button": true,
  "navbar": false,
  "title": false,
  "toolbar": {
    zoomIn: 1,
    zoomOut: 1,
    oneToOne: 1,
    reset: 0,
    prev: 0,
    play: 0,
    next: 0,
    rotateLeft: 1,
    rotateRight: 1,
    flipHorizontal: 0,
    flipVertical: 0,
  },
  "tooltip": true,
  "movable": true,
  "zoomable": true,
  "rotatable": true,
  "scalable": true,
  "transition": true,
  "fullscreen": true,
  "keyboard": true,
  "url": "data-source"
});
const i18n = new VueI18n({
  locale: localStorage.i18n || 'zh-CN', // 语言标识
  messages: {
    'zh-CN': require('./lang/zh'), // 中文语言包
    'en-US': require('./lang/en'), // 英文语言包
    'de-GY': require('./lang/de') // 德文语言包
  }
})

// 报错
Vue.prototype.$messageError = (name) => {
  ElementUI.Message.error({
    showClose: true,
    message: typeof (name) == "string" ? name : '出错啦，请稍后重试'
  })
}
// 成功
Vue.prototype.$messageSuccess = (name) => {
  ElementUI.Message.success({
    showClose: true,
    message: name
  })
}
// 警告
Vue.prototype.$messageWarning = (name) => {
  ElementUI.Message.warning({
    showClose: true,
    message: name
  })
}
// 消息
Vue.prototype.$messageInfo = (name) => {
  ElementUI.Message.info({
    showClose: true,
    message: name
  })
}

// 权限检查方法（且把该方法添加到vue原型中）
Vue.prototype.$_has = function (value) {
  // let isExist = false
  // 从浏览器缓存中获取权限数组（该数组在登入成功后拉取用户的权限信息时保存在浏览器的缓存中）
  var str = sessionStorage.getItem('btnPermissions');
  if(str){
    try {
      let buttonpermsStr = AES.AES_Decrypt(str)
      return buttonpermsStr.includes(value)
    }catch (e) {
      console.error( 'main.js',e);
      return  false
    }
  }else{
    return  false
  }

}
//退出
Vue.prototype.$logOut = () => {
  if (localStorage.getItem('Authorization')) {
    let prodId = sessionStorage.getItem('prodId')
    if (prodId) {
      axios({
        method: "post",
        url: `${process.env.BASE_API}/api-user/sys/menu/exitLogin`,
        data: {
          prodId: prodId
        },
        headers: {
          Authorization: "bearer " + localStorage.getItem("Authorization"),
        },
      }).then(rs => {
        goOut()
      }).catch(err => {
        console.log(err)
      })
    } else {
      goOut()
    }
  } else {
    localStorage.clear();
    sessionStorage.clear();
    router.push({path: '/'})
  }
}

function goOut(){
  axios.get(process.env.BASE_API + '/api-oauth/oauth2/exit/' + localStorage.getItem('Authorization')).then((rs) => {
    localStorage.clear();
    sessionStorage.clear();
    router.push({path: '/'})
  })
}

// 埋点
Vue.directive('bury', {
  bind(el, binding) {
    el.addEventListener('click', () => {
      const data = binding.value;
      let time = new Date().getTime();
      if (data.start) {
        window.sessionStorage.setItem('startTime', time);
      } else {
        let ext = {}
        if (data.template && data.template.length) {
          ext = {
            name: data.template[0].eventName,
            eventId: data.template[0].id,
            browser: navigator.userAgent  // 浏览器版本
          };
        }
        if (data.route && data.route.meta) {
          data.route.meta.time = window.sessionStorage.getItem('startTime');
        }

        let from = {
          ...data.route,
          ext: JSON.stringify(ext)
        }
        let to = {
          fullPath: "",
          hash: "",
          meta: {time: time},
          name: undefined,
          params: {},
          path: "",
          query: {},
        };
        analyticsRequest(to, from)
      }
    }, false);
  }
});
// wjl 埋点
const analyticsRequest = (to, from) => {
  // 只统计页面跳转数据，不统计当前页 query 不同的数据
  // 所以这里只使用了 path, 如果需要统计 query 的，可以使用 to.fullPath
  let time = new Date().getTime();
  if (to.fullPath !== from.fullPath) {
    if (from.meta.time && (time - from.meta.time) > 5 * 1000) {
      let data = {
        ext: from.ext,
        "endTime": time,
        "routeUrl": process.env.BASE_API + from.fullPath,
        "startTime": Number(from.meta.time),
        "time": Math.ceil((time - from.meta.time) / 1000),
        "userId": window.sessionStorage.getItem('userId')
      }
      axios.post(process.env.BASE_API + '/api-action/apilog/save', data, {
        headers: {'Authorization': 'bearer ' + localStorage.getItem('Authorization')}
      }).then(() => {
      })
    }
  }
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js